module.exports = __webpack_public_path__ + "static/media/sad-face_icon.0bb1245f.svg";